import { render, staticRenderFns } from "./LoginLocal.vue?vue&type=template&id=29fa8ca0&scoped=true"
import script from "./LoginLocal.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginLocal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LoginLocal.vue?vue&type=style&index=0&id=29fa8ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fa8ca0",
  null
  
)

export default component.exports